import { render, staticRenderFns } from "./Privacy.html?vue&type=template&id=5b9c9486&scoped=true&"
import script from "./Privacy.ts?vue&type=script&lang=ts&"
export * from "./Privacy.ts?vue&type=script&lang=ts&"
import style0 from "./Other.css?vue&type=style&index=0&id=5b9c9486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c9486",
  null
  
)

export default component.exports